// extracted by mini-css-extract-plugin
export default {"container":"RTskW","listItem":"qEh5T","desktopListItem":"RMdOR","withFooter":"_4yGhL","mobileListItem":"DnV-L"};